import { TAdvertisersReportChartFilters } from '../../../models/types'

export const selectAdvertisersChartReportingFilters = ({
  reportingFilters: reportingAdvertisersChartFiltersState,
}: {
  reportingFilters: TAdvertisersReportChartFilters
}): TAdvertisersReportChartFilters => reportingAdvertisersChartFiltersState
